/*
 *   File : accordion.js
 *   Author : https://evoqins.com
 *   Description : accordion component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { useRef, useEffect, useState } from "react";
import Icon from "../icons";
import { Chip } from "../Other";

export default function Accordion({
  title,
  img,
  chipVal,
  isOpen,
  onClick,
  children,
}) {
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (isOpen) {
      const scrollHeight = contentRef.current.scrollHeight;
      setHeight(scrollHeight);
    } else {
      setHeight(0);
    }
  }, [isOpen]);

  return (
    <div
      onClick={onClick}
      className="e-cursor-pointer w-100 bg-white-smoke-48 bg-opacity-48 border-white rounded-16"
    >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center w-100 text-black">
        <div className="d-flex align-items-center column-gap-2 p-20">
          {img && (
            <img
              src={require("../../Assets/Images/bank.png")}
              alt={title}
              width={24}
              className="object-fit-contain"
            />
          )}

          <h6 className="m-0 fs-14 lh-18 fw-400">{title}</h6>

          <Chip
            text={chipVal}
            style="px-2 py-1 bg-lavender-blue bg-opacity-43"
            textClr="text-facebook-blue"
          />
        </div>

        <div className="p-20">
          <Icon icon={isOpen ? "chevron-up" : "chevron-down"} size="20px" />
        </div>
      </div>

      {/* Animated Body */}
      <div
        ref={contentRef}
        className="accordion-body-wrapper"
        style={{
          maxHeight: height,
          opacity: isOpen ? 1 : 0,
          transition: "max-height 0.35s ease, opacity 0.25s ease",
          overflow: "hidden",
        }}
      >
        <div className="mt-2 w-100">{children}</div>
      </div>
    </div>
  );
}
